<template>
    <div class="acessibilidade" style="margin-top: -40px">
        <div class="content">
            <div class="flex-column flex-stretch">
                    <div class="pa-2" v-if="!acordoCredito">
                        <div class="card my-card" style="background-color: #E8F5E9; height: 100%; max-width: fit-content" :style="[!small ? {'min-width': '400px !important'} : '']">
                            <article class="text-justify pa-4">
                                Por motivos de segurança, seu boleto pode requisitar senha para ser aberto. Esta senha são os quatro primeiros números do seu CPF/CNPJ.
                                Exemplo: Se o seu CPF/CNPJ for 09899, digitar 0989 para abrir o boleto
                                Caso não consiga visualizar o boleto anexado, acesse o link abaixo e faça o download do programa Adobe Acrobat PDF.
                                <a href="http://get.adobe.com/br/reader/"> http://get.adobe.com/br/reader/</a>
                            </article>
                        </div>
                    </div>
                <div class="flex-row flex-wrap flex-stretch" >
                    <div class="pa-2">
                        <div class="card my-card pb-5" style="background-color: #C8E6C9; height: 100%" :style="[!small ? {'min-width': '400px !important'} : '']">
                            <h4 class="text-center py-4 px-3" style="color: #1B5E20">Acordo realizado com sucesso!</h4>
                            <div class="py-3 text-center content-card-acordo">
                                <div v-for="(item, i) in retornoAcordo.detalhes" :key="i">
                                    {{item.Titulo}}: <br>
                                    {{item.Valor}}
                                    <hr v-if="(i+1) !== detalhes.length">
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="pa-2 flex-column flex-between" v-if="!acordoCredito && retornoAcordo.permiteEmissaoBoleta">
                        <!-- <div class="flex-column" style="justify-content: center !important"> -->
                            <div class="card my-card content pa-2" style="background-color: #E1F5FE" >
                                <h4 class="text-center py-2 px-3" style="color: #3B6589"> <i class="fas fa-check-circle"></i> Negociação finalizada com sucesso!</h4>
                                <button class="btn bg-azul-dark" style="color: white; width: 150px" @click="imprimirBoleta()">
                                    <i class="fas fa-print pr-2"></i>
                                    Gerar Boleto
                                </button>
                            </div>
                            <div class="card my-card content pa-2 mt-3" style="background-color: #E1F5FE" >
                                <h4 class="text-center py-2 px-3" style="color: #3B6589"><i class="fas fa-paper-plane"></i> Envie a linha digitável para o seu celular!</h4>
                                <button class="btn bg-azul-dark" style="color: white; width: 150px" @click="enviarBoletaSMS()">
                                    <i class="fas fa-sms pr-2"></i>
                                    Enviar Sms
                                </button>
                            </div>
                            <div class="card my-card content pa-2 mt-3" style="background-color: #E1F5FE" >
                                <h4 class="text-center py-2 px-3" style="color: #3B6589"><i class="fas fa-mail-bulk"></i> Envie a boleta para o seu email!</h4>
                                <button class="btn bg-azul-dark" style="color: white; width: 150px" @click="enviarBoletaEmail()">
                                    <i class="fas fa-envelope pr-2"></i>
                                    Enviar Email
                                </button>
                            </div>
                        <!-- </div> -->
                    </div>
                    <div class="pa-2 flex-column flex-between" v-if="retornoAcordo.pgtooutrosMeios">                        
                        <p>
                        <span v-html="retornoAcordo.dsmensagemOutrosMeios"></span> 
                        </p>     
                    </div>
                </div>
                <div class="flex-row flex-wrap">
                    <div class="pa-2" v-show="divida.ConfissaoDivida != 0">
                        <div  class="card my-card content pa-2 mt-3" style="background-color: #FFF3E0" :style="[!small ? {'min-width': '400px !important'} : '']">
                            <button class="btn" style="color: white; background-color: #FF7043" @click="verTermoConfissao()">
                                <i class="fas fa-file-contract pr-2"></i>
                                Termo de Confissão
                            </button>
                        </div>
                    </div>
                    <div class="pa-2" v-show="divida.TermoAceite != 0">
                        <div class="card my-card content pa-2 mt-3" style="background-color: #FFF3E0" :style="[!small ? {'min-width': '400px !important'} : '']">
                            <button class="btn" style="color: white; background-color: #FF7043" @click="verTermoAcordo()">
                                <i class="fas fa-file-contract pr-2"></i>
                                Termo de Acordo
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-dialog v-model="activeDialog" role="dialog" aria-haspopup="false">
            <v-card>
                    <h3 id="titleDialog" tabindex="-1" class="headline grey lighten-2 pa-3">
                        {{titleDialog}}
                        <v-btn class="right" aria-label="Fechar" icon @click="activeDialog = false" style="margin-top: -5px"><i class="fas fa-times fa-2x" style="color: grey "></i></v-btn>
                    </h3>
                <v-card-text  >
                    <center-element class="pt-3">
                        <div class=" scroll-y scroll-x style-teste"  style="max-width: 900px">
                            <div id="termo" role="document"></div>
                        </div>
                    </center-element>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {getBoletaSMS, postBoletaEmail, getArquivoBoleta} from '@/service/service_autoatendimento/boleta'
import { getTermoConfissao, getTermoAcordo } from '@/service/service_autoatendimento/documento'
//import { getDetalheAcordo, getEmails } from '@/service/service_autoatendimento/autoatendimento'
import { getDetalheAcordo } from '@/service/service_autoatendimento/autoatendimento'
import CenterElement from './MyComponents/CenterElement.vue'
import bus from '@/service/bus'
import $ from 'jquery'
export default {
    props: ['chave', 'divida', 'small', 'acordoCredito'],
    components: { CenterElement },
    data() {
        return {
            activeDialog: false,
            detalhes: [],
            titleDialog: '',
            retornoAcordo :{
                pgtooutrosMeios : false,
                dsmensagemOutrosMeios : '',
                permiteEmissaoBoleta : true,
                detalhes: []
            }
        }
    },
    mounted() {
        // this.detalhes = []
        if(this.chave != undefined) {
            getDetalheAcordo(this.chave).then(response => {
                this.retornoAcordo = response.data.Retorno

            }).catch(() => {
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: 'Erro ao carregar detalhes do acordo.'
                })
            })

        }
    },
    methods: {
        imprimirBoleta() {
            try {
                bus.$emit('load-in', {text: 'Carregando'})
                getArquivoBoleta(this.chave).then(response => {
                    bus.$emit('load-out')
                    let base = response.data.Retorno.arquivoPDFBase64
                    let bin = atob(base.replace(/\s/g, ''))
                    let len = bin.length
                    let buffer = new ArrayBuffer(len)
                    let view = new Uint8Array(buffer)
                    for(let i=0; i<len; i++) {
                        view[i] = bin.charCodeAt(i)
                    }
                    let pdfBlob = new Blob([view], {type: "application/pdf"})
                    let url = URL.createObjectURL(pdfBlob)
                    window.open(url)
                }).catch((error) => {
                    bus.$emit('load-out')
                    this.$swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: error.response.data.Message
                    })
                })
            } catch(error) {
                bus.$emit('load-out')
                this.$swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data.Message
                })
            }
            
        },
        enviarBoletaSMS() {
            this.$swal({
                input: 'text',
                title: 'Informe um número de celular:',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText:'Enviar',
                reverseButtons: true,
                inputAttributes: {
                    id: 'myInput',
                    maxlength: 11
                },
                showLoaderOnConfirm: true,
                inputValidator: (value) => {
                    if (!value) return 'Informe um número de celular'
                    else {
                        let txt = value.replace(/([(]|[)]|-| )/g, '')
                        if (isNaN(txt) || txt.length !== 11) return 'Número inválido'
                    } 
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
                onOpen: (el) => {
                    var container = $(el)
                    container.find('#myInput').mask('(00) 00000-0000')
                },
                preConfirm: (ret) => {
                    let obj = {
                        telefone: ret.replace(/([(]|[)]|-| )/g, ''),
                        chave: this.chave
                    }
                    try {
                        return getBoletaSMS(obj).then(() => {
                        }).catch(error => {
                            this.$swal.showValidationMessage(`Erro: ${error.message}`)
                        })
                    } catch (er) {
                        this.$swal.showValidationMessage(`Erro: ${er.message}`)
                    }
                }
            }).then((result) => {
                if(result.value) {
                    this.$swal({
                        type: 'success',
                        title: 'SMS enviado!'
                    })
                }
            })            
        },
        enviarBoletaEmail() {
            this.$swal({
                input: 'email',
                title: 'Informe o e-mail de destino:',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText:'Enviar',
                reverseButtons: true,
                inputAttributes: {
                    id: 'myInput',
                    maxlength: 100
                },
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !this.$swal.isLoading(),
                preConfirm: (ret) => {
                    let obj = {
                        emailDestino: ret,
                        chave: this.chave
                    }
                    try {
                        return postBoletaEmail(obj).then(() => {
                        }).catch(error => {
                            this.$swal.showValidationMessage(`Erro: ${error.message}`)
                        })
                    } catch (er) {
                        this.$swal.showValidationMessage(`Erro: ${er.message}`)
                    }
                }
            }).then((result) => {
                if(result.value) {
                    this.$swal({
                        type: 'success',
                        title: 'E-mail enviado!'
                    })
                }
            })   
        },
        verTermoAcordo() {
                let obj = {
                    chaveDivida: this.divida.chaveDivida,
                    codigo: this.divida.TermoAceite
                }
                bus.$emit('load-in', {text: 'Carregando'})
                getTermoAcordo(obj).then(response => {
                    bus.$emit('load-out')
                    let d = document.getElementById('termo')
                    d.innerHTML = response.data.Retorno
                    this.titleDialog = 'Termo de Acordo'
                    this.activeDialog = true
                    setTimeout(() => {
                        let title = document.getElementById('titleDialog')
                        title.focus()
                    }, 500)
                }).catch(() => {
                    bus.$emit('load-out')
                })
        },
        verTermoConfissao() {
            let obj = {
                chaveNegociacao: this.chave,
                codigo: this.divida.ConfissaoDivida,
                parcela: 0
            }
            bus.$emit('load-in', {text: 'Carregando'})
            getTermoConfissao(obj).then(response => {
                bus.$emit('load-out')
                let d = document.getElementById('termo')
                d.innerHTML = response.data.Retorno
                this.titleDialog = 'Termo de Confissão'
                this.activeDialog = true
                setTimeout(() => {
                    let title = document.getElementById('titleDialog')
                    title.focus()
                }, 500)
            }).catch(() => {
                bus.$emit('load-out')
            })
        }
    }
}
</script>
<style>
.my-card {
    max-width: 400px;
    min-width: 300px;
    box-shadow: 0px 1px 2px 0.2px #90A4AE;
    padding: 5px;
}
.content-card-acordo {
    background-color: #E8F5E9;
    border-radius: 6px;
}
</style>
